var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadcastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21157_184031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6907 14.4538C9.71603 14.5169 9.76006 14.5708 9.81688 14.6082C9.87371 14.6455 9.9406 14.6646 10.0086 14.6629C10.0766 14.6611 10.1424 14.6386 10.1973 14.5984C10.2521 14.5582 10.2933 14.5021 10.3154 14.4378L14.6487 1.77112C14.67 1.71205 14.6741 1.64813 14.6604 1.58683C14.6468 1.52553 14.6159 1.46939 14.5715 1.42498C14.5271 1.38056 14.471 1.34972 14.4097 1.33605C14.3484 1.32238 14.2844 1.32645 14.2254 1.34779L1.5587 5.68112C1.49436 5.70319 1.43832 5.7444 1.39808 5.79924C1.35785 5.85407 1.33535 5.9199 1.33361 5.9879C1.33186 6.05589 1.35096 6.12278 1.38834 6.17961C1.42571 6.23643 1.47958 6.28046 1.5427 6.30579L6.82937 8.42579C6.99649 8.4927 7.14833 8.59276 7.27574 8.71994C7.40315 8.84712 7.50349 8.99879 7.5707 9.16579L9.6907 14.4538Z",
    stroke: "#5921F2",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5692 1.42969L7.27588 8.72235",
    stroke: "#5921F2",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21157_184031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastIcon);
export default __webpack_public_path__ + "static/media/BroadcastIcon.050b9b5b21811056535d551ceefc3f84.svg";
export { ForwardRef as ReactComponent };